import { useCallback } from 'react';

export const useFormikOnChange = (name, onChange) =>
  useCallback((value) => onChange(name, value), [onChange, name]);
